export const formatNumberWithCommas = (x: number, decimals: number): string => {
  const parts = x.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const padWithZero = (num: number | string) => (String(num) !== '0' ? String(num).padStart(2, '0') : '0');
